import {
  Box,
  LinearProgress,
  TextField,
  Toolbar as ToolbarBase,
  styled,
} from '@mui/material';

export const Toolbar = styled(ToolbarBase)`
  padding: 0 !important;
  min-height: ${(p) => p.theme.spacing(4.75)} !important;
`;

export const LogoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 25%;
  justify-content: center;
  padding: 0 ${(p) => p.theme.spacing(1)};
  background-color: ${(p) =>
    p.theme.palette.mode === 'dark'
      ? p.theme.palette.grey[800]
      : p.theme.palette.common.white};
`;

export const LoadingBar = styled(LinearProgress)`
  height: 1px;
`;

export const HeaderTopRightContainer = styled(Box)`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${(p) => p.theme.spacing(1.5)};
  padding: ${(p) => p.theme.spacing(0, 1)};
`;

export const StyledSearchInput = styled(TextField)`
  padding: ${(p) => p.theme.spacing(1)};
  width: 100%;

  & input::placeholder {
    font-size: ${(p) => p.theme.typography.body4.fontSize};
    font-weight: ${(p) => p.theme.typography.fontWeightRegular};
    color: ${(p) => p.theme.palette.grey[400]};
    padding-left: ${(p) => p.theme.spacing(0.5)};
  }

  & > .MuiInputBase-root:hover,
  .MuiInputBase-root:focus-visible {
    & > .MuiOutlinedInput-notchedOutline {
      border-color: ${(p) => p.theme.palette.primary[400]};
    }
  }
`;
